module.exports = __webpack_public_path__ + "static/media/filter.8bbf46a0.svg";